import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';

import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import {
    getMonthlySubscriptionData, handleLoader
} from '../../../../redux/actions/MonthlySubscriptionActions';
import { findMonthsBetweenDates } from '../../../../utils/helpers';
import { months, tableHeaderDataMonthlyOrderSub, filterShowWise } from '../../helper';
import ViewMonthlySubOrderModel from './ViewMonthlySubOrderModel';
import MonthlyOrderByCateg from './MonthlyOrderByCateg';

const MonthlySubscription = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const [currentYear, currentMonth] = moment().format('YYYY-MMM').split('-');
    const [prevYear, prevMonth] = moment().subtract(1, 'year').format('YYYY-MMM').split('-');

    const { isLoading, monthlySubscriptionData, salesChannelFilterData } = useSelector(
        ({ monthlySubscriptionReducer, marketPlaceReducer }) =>
        ({
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            monthlySubscriptionData: monthlySubscriptionReducer.monthlySubscriptionData,
            isLoading: monthlySubscriptionReducer.isLoading,
        })
    );

    const filtersObj = monthlySubscriptionData?.modal?.filters?.[0];

    const [monthlySubscriptionDataToShow, setMonthlySubscriptionData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [currentlyShow, setCurrentlyShow] = useState(filterShowWise.slice(0, 3).slice(0, 3)?.[0]);

    const [filterData, setFilterData] = useState({});
    const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth });
    const [month1, setMonth1] = useState({ year: prevYear, month: prevMonth })
    const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
    const [tempMonth1, setTempMonth1] = useState({ year: prevYear, month: prevMonth })

    const yearOptions = [];
    for (let year = 2016; year <= currentYear; year += 1) {
        yearOptions.push({ label: year, value: year })
    }

    const monthOptions = months.map(item => ({ label: item, value: item }));
    const date1 = `${month1?.year}-${month1?.month}`;
    const date2 = `${month2?.year}-${month2?.month}`;

    const filterBasedOnFilter = (item, monthlySubscriptionDataToShowMonthWise) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }

        if (flag && Number(item.subscribed)) {
            const { salesMonth, salesYear } = item;
            const key = `${salesMonth}-${salesYear}`
            if (item?.salesMonth && monthlySubscriptionDataToShowMonthWise[key]) {
                monthlySubscriptionDataToShowMonthWise[key]?.push(item)
            } else {
                // eslint-disable-next-line no-param-reassign
                monthlySubscriptionDataToShowMonthWise[key] = [item]
            }
        } else {
            return false
        }

        return flag
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartV = document.getElementById('dvChartView');
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Monthly Subscription Report ${new Date().getFullYear()}`,
    })
    dvChartV.style.display = "block"; 
  }

    const callApi = ({ tempMon1, tempMon2 }) => {
        const data = {
            from: tempMon1?.year, to: tempMon2?.year,
            fromMonth: moment(tempMon1?.month, 'MMM').format('MMM'),
            toMonth: moment(tempMon2?.month, 'MMM').format('MMM'),
        }
        dispatch(handleLoader(true))
        dispatch(getMonthlySubscriptionData(data));
    }

    const handleApplyDate = () => {
        const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
        const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

        const monthsBetween = findMonthsBetweenDates(startDate, endDate);
        if (monthsBetween?.length > 0) {
            setMonth1(tempMonth1);
            setMonth2(tempMonth2);
            callApi({ tempMon1: tempMonth1, tempMon2: tempMonth2 });
        } else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'Please select maximum one year data'
                });
            });
        }
    }

    const handleYearMonthChange = ({ isFrom, field, value }) => {

        if (isFrom) {
            setTempMonth1({ ...tempMonth1, [field]: value?.value });
        } else {
            setTempMonth2({ ...tempMonth2, [field]: value?.value });
        }
    }

    const viewReportButton = () => (
        <div className="view-report" style={{ right: '15px', top: '10px' }}>
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
            >
                View Report
            </button>
        </div>
    )


    // eslint-disable-next-line react/prop-types
    const RenderYearAndMonth = ({ isFrom }) => (
        <Col sm="4" className="">
            <Row className="align-items-center">
                <Col sm="5" className="">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Year</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                                    : { value: tempMonth2?.year, label: tempMonth2?.year }}
                                options={yearOptions}
                                clearable={false}
                                placeholder="Select Year"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'from' : 'to'}
                            />
                        </div>

                    </div>
                </Col>
                <Col sm="5" className="">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Month</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                                    : { value: tempMonth2?.month, label: tempMonth2?.month }}
                                options={monthOptions}
                                clearable={false}
                                placeholder="Select Month"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'fromMonth' : 'toMonth'}
                            />
                        </div>
                    </div>
                </Col>
                {isFrom ? <Col sm="2" className=" top-10 text-center">~</Col> : null}
            </Row>

        </Col>
    );

    const changeFilter = (value) => {
        setCurrentlyShow(value)
    };

    useEffect(() => {
        dispatch(handleLoader(true));
        callApi({ tempMon1: tempMonth1, tempMon2: tempMonth2 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setMonthlySubscriptionData(monthlySubscriptionData?.modal?.data?.[0]?.yearlySales || []);
    }, [monthlySubscriptionData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData]);

    let monthlySubscriptionDataToShowForDatesSelected = [];
    const monthlySubscriptionDataToShowMonthWise = {}
    const monthsBetweenDates = findMonthsBetweenDates(date1, date2);

    Object.keys(monthlySubscriptionDataToShow).forEach((year) => {
        if (Object.keys(monthlySubscriptionDataToShow?.[year]?.monthlyProductSales).length) {
            Object.keys(monthlySubscriptionDataToShow?.[year]?.monthlyProductSales).forEach((month) => {
                const monthData = monthlySubscriptionDataToShow?.[year]?.monthlyProductSales[month] || []
                const updatedMonthData = monthData.map((item) => {
                    const updated = {
                        ...item,
                        salesMonth: month,
                        salesYear: year,
                    }
                    return updated
                })
                monthlySubscriptionDataToShowForDatesSelected =
                    monthlySubscriptionDataToShowForDatesSelected.concat(updatedMonthData)
            })
        }
    })

    monthlySubscriptionDataToShowForDatesSelected = monthlySubscriptionDataToShowForDatesSelected?.filter(item =>
        filterBasedOnFilter(item, monthlySubscriptionDataToShowMonthWise));

    console.log('monthlySubscriptionDataToShowForDatesSelected', monthlySubscriptionDataToShowForDatesSelected, monthlySubscriptionDataToShowMonthWise, filterData)

    return (
        <Container className="dashboard">
            <Row className="monthly-subscription-order">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">Monthly subscription orders </h5>
                            </div>
                            <Row className="align-items-center">
                                <Col sm="2" className="pr-0">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Show</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={currentlyShow}
                                                options={filterShowWise.slice(0, 3)}
                                                clearable={false}
                                                placeholder="Select "
                                                className="select_filter"
                                                onChange={value => changeFilter(value)}
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                    </div>
                                </Col>
                                <Col md="10">
                                    <Row className="align-items-center">
                                        <RenderYearAndMonth isFrom />
                                        <RenderYearAndMonth />
                                        <Col sm="4" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="pb-3">
                <CardBody className="">
                <div id="divToPrint" ref={container}>
                    <Row className="show-sales-region">
                        <Col md="12">
                            <Card>
                                <CardBody className="p-0">
                                    <div className="top-location" style={{ minHeight: '400' }}>
                                        <div >
                                            {isLoading ? <div style={{ minHeight: '200px' }}
                                                className="row align-items-center justify-content-center">
                                                <SmallLoader loading={isLoading} />
                                            </div>
                                                : <MonthlyOrderByCateg
                                                    viewReportButton={viewReportButton}
                                                    dir={rtl.direction}
                                                    dataMonthWise={monthlySubscriptionDataToShowMonthWise}
                                                    data={monthlySubscriptionDataToShowForDatesSelected}
                                                    title={`Monthly subscription orders By ${currentlyShow?.label}`}
                                                    categorisedBasedOn={currentlyShow?.value}
                                                    currentlyShow={currentlyShow}
                                                    monthsBetweenDates={monthsBetweenDates}
                                                    height={400}
                                                />}
                                        </div>
                                    </div>
                                    <ViewMonthlySubOrderModel
                                        data={monthlySubscriptionDataToShowForDatesSelected}
                                        isOpen={isOpen}
                                        handleModal={setIsOpen}
                                        fileName="Montly Subscription Order Report"
                                        tableHeaderData={tableHeaderDataMonthlyOrderSub}
                                        title="Monthly subscription orders"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    </div>
                </CardBody>
            </Card>

        </Container>
    );
};

MonthlySubscription.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default connect(state => ({
    rtl: state.rtl,
}))(MonthlySubscription);
